import type { TFunction } from 'i18next';
import type { PrintQualityWarning } from '@/services/orderService';

export const PRINT_QUALITY_MIN_PPI = 300;

export interface PrintQualityWarningSource {
  readonly printQualityWarning?: PrintQualityWarning | null;
}

export const getPrintQualityWarningLabel = (
  source: PrintQualityWarningSource | null | undefined,
  t: TFunction,
): string | null => {
  if (!source) {
    return null;
  }

  const warning = source.printQualityWarning;
  if (warning?.type === 'LOW_PPI') {
    return t(
      'uploadedImages.printQualityWarning',
      'Low print quality: {{ppi}} PPI. Recommended minimum is {{threshold}} PPI.',
      { ppi: Math.round(warning.ppi), threshold: warning.threshold },
    );
  }
  return null;
};
